export const FETCH_TIEMPO_REQUEST = 'FETCH_TIEMPO_REQUEST';
export const FETCH_TIEMPO_SUCCESS = 'FETCH_TIEMPO_SUCCESS';
export const FETCH_TIEMPO_FAILURE = 'FETCH_TIEMPO_FAILURE';

function requestTiempoPosts() {
    return {
        type: FETCH_TIEMPO_REQUEST,
        isFetching: true,
    };
}

function fetchTiempoSuccess(timeFilter) {
    return {
        type: FETCH_TIEMPO_SUCCESS,
        isFetching: false,
        timeFilter,
    };
}

function fetchTiempoError(message) {
    return {
        type: FETCH_TIEMPO_FAILURE,
        isFetching: false,
        message,
    };
}

export function obtenerFiltroFecha() {
    const config = {
        method: 'post',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query: '{infoGeneral{ejecutivo, idinfo_general}}',
        }),
        credentials: 'include',
    };

    return dispatch => {
        dispatch(requestTiempoPosts());

        return fetch('/graphql', config)
            .then(response =>
                response.json().then(responseJson => ({
                    selectTiempo: responseJson.data.timeFilter,
                    responseJson,
                })),
            )
            .then(({ selectTiempo, responseJson }) => {
                if (!responseJson.data.filtrosTiempo) {
                    // If there was a problem, we want to
                    // dispatch the error condition
                    dispatch(fetchTiempoError(selectTiempo.message));
                    //console.log(posts)
                    return Promise.reject(selectTiempo);
                }
                // Dispatch the success action
                //console.log(posts)
                dispatch(fetchTiempoSuccess(selectTiempo));
                return Promise.resolve(selectTiempo);
            })
            .catch(err => console.error('Error: ', err));
    };
}
